
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticProps, GetStaticPropsContext } from 'next';
import styled from 'styled-components';
import { Review } from 'shared/api/latestReviews';
import Page from 'shared/components/Page';
import useTranslation from 'shared/hooks/useTranslation';
import getReviews from 'lib/cache/latestReviews/reviews';
import TeamTrustMate from 'modules/ourTeam/TeamTrustMate';
import dynamic from 'next/dynamic';
import Head from 'next/head';
const LogosInLine = dynamic(() => import('modules/ourTeam/LogosInLine'));
const Statistics = dynamic(() => import('modules/ourTeam/Statistics'));
const Management = dynamic(() => import('modules/ourTeam/Management'));
const Departments = dynamic(() => import('modules/ourTeam/Departments'));
const JoinTrustMateCarousel = dynamic(() => import('modules/ourTeam/JoinTrustMateCarousel'));
const SocialMedia = dynamic(() => import('modules/ourTeam/SocialMedia'));
type OurTeamProps = {
    latestReviews: Review[];
};
function OurTeam({ latestReviews }: OurTeamProps): JSX.Element {
    const { t, lang } = useTranslation('ourTeamPage');
    return (<Page reviews={latestReviews} withFooter withLatestReviews>
      <Head>
        <title>Team TrustMate!</title>
        <meta property="og:title" content={t('chooseTrustMate')} key="title"/>
        <meta property="og:description" content={t('meetOurExperts')}/>
        <meta property="og:image" content="https://cdn.trustmate.io/team.jpg"/>
        <meta property="twitter:card" content="https://cdn.trustmate.io/team.jpg"/>
        <meta property="og:type" content="website"/>
        <meta property="og:locale" content={`${lang}_${lang.toUpperCase()}`}/>
      </Head>
      <StyledMain>
        <TeamTrustMate />
        <LogosInLine />
        <Statistics />
        <Management />
        <Departments />
        <JoinTrustMateCarousel />
        <SocialMedia />
      </StyledMain>
    </Page>);
}
const StyledMain = styled.main `
  @media ${({ theme }) => theme.DEVICE.LG} {
    margin: 0 3.2rem 0 3.2rem;
  }
`;
const getStaticProps: GetStaticProps<OurTeamProps> = async (context: GetStaticPropsContext) => {
    const latestReviews = await getReviews({
        language: context.locale as string,
    });
    return {
        props: { latestReviews },
        revalidate: 60,
    };
};
export default OurTeam;

    async function __Next_Translate__getStaticProps__197e4b1fd86__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/our-team',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__197e4b1fd86__ as getStaticProps }
  